import { Component, inject, signal } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { NotificationService } from './core/notification.service';
import { SelectionService } from './core/selection.service';

@Component({
  selector: 'cd-root',
  imports: [RouterOutlet, RouterLink, RouterLinkActive],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  protected readonly notifications = inject(NotificationService);
  protected readonly selection = inject(SelectionService);

  /** Name, tagline and logo come from the environment file, not from this component. */
  protected readonly branding = environment.branding;

  protected readonly menuOpen = signal(false);

  /** Set when the configured logo fails to load, so the header falls back to text. */
  protected readonly logoFailed = signal(false);

  protected toggleMenu(): void {
    this.menuOpen.update((open) => !open);
  }

  protected closeMenu(): void {
    this.menuOpen.set(false);
  }

  protected onLogoError(): void {
    // A missing branding asset should not leave a broken image in the header.
    this.logoFailed.set(true);
  }
}
